import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../utils/redux/userSlice';
import { Machine } from '../utils/models/Machine';
import MachineForm from '../components/MachinesComponents/MachineForm/MachineForm.component';
import MachineGrid from '../components/MachinesComponents/MachineGrid/MachineGridTable.component';
import ModalComponent from '../components/ModalCompnent/modal.component';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { downloadFile, generateFile } from '../utils/libs/filesFunc';
import { Instalation } from '../utils/models/Instalation';
import { IOutletContext } from '../utils/interfaces/IOutletContext';
import { getAllInstalations } from '..//utils/services/instalation.service';
import {
    deleteMachine,
    getAllMachines,
    newMachine,
    getMachinesPage,
} from '../utils/services/machine.service';
import { IToastProps, NotificationToast } from 'aw-notificationtoast';
import  { ButtonsLine }  from 'aw-management-buttons-line';
import { ISelectOptions } from 'aw-combobox';
import { ROLES } from 'aw-consts';
import { ColumnFiltersState, SortingState } from '@tanstack/react-table';
import { SearchPanel }  from 'aw-search-panel';

const MachinesPage = () => {
    const { t } = useTranslation();
    const [manual, setManual] = useState(true);

    const [isNew, setIsNew] = useState(false);
    const [loding, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [toast, setToast] = useState<IToastProps>({ showToast: false, msg: '', fail: false });
    const [newEditDelObj, setNewEditDelObj] = useState(new Machine());
    const [machines, setMachines] = useState<Machine[]>([]);
    const [formLock, setFormLock] = useState(false);
    const [allInstalations, setAllInstalations] = useState<Instalation[]>([]);
    const [allInstalationsObj, setAllInstalationsObj] = useState<ISelectOptions[]>([]);
    const [selectedInstalation, setSelectedInstalation] = useState<ISelectOptions>();
    const [sorting, setSorting] = useState<SortingState>([]);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
    const [total, setTotal] = useState(0);
    const [filters, setFilters] = useState<ColumnFiltersState>([]);
    const user = useSelector(selectUser);
    const context: IOutletContext = useOutletContext();
    const [query, setQuery] = useState<string>('');

    useEffect(() => {
        context.setState(t('Machines'));
    });

    useEffect(() => {
        manual ? getMachinesPageAux() : getAllMachinesAux();

        getAllInstalationsAux();
    }, []);

    const showToastTimeOut = (msg: string, failToast: boolean) => {
        setToast({ showToast: true, msg: msg, fail: failToast });
        setTimeout(() => setToast({ showToast: false, msg: msg, fail: failToast }), 2000);
    };

    const newClick = () => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noCreatePermissions'), true);
        } else {
            setSelectedInstalation(allInstalationsObj[0]);
            const instalation = allInstalations.find(
                (i: Instalation) => i.idinstalation === allInstalationsObj[0].value
            );
            if (instalation) {
                setNewEditDelObj(prevValues => ({
                    ...prevValues,
                    instalation: instalation,
                }));
            }
            setFormLock(false);
            setIsNew(true);
        }
    };

    useEffect(() => {
        setPagination(p => (p.pageIndex === 0 ? p : { ...p, pageIndex: 0 }));
    }, [filters, sorting,query]);

    const getMachinesPageAux = (s?:string) => {
    const PAGE_SIZE = 2;
    getMachinesPage(
        user.token,
        pagination.pageIndex + 1,
        pagination.pageSize || PAGE_SIZE,
        filters,
        sorting[0]?.id,
        sorting[0]?.desc ? 'DESC' : 'ASC',
        query  
    )
        .then(json => {
            setMachines(json.data);
            setTotal(json.totalPages);
        })
        .catch(() => showToastTimeOut(t('ErrorLoad'), true))
        .finally(() => setTimeout(() => setLoading(false), 500));
};

    useEffect(() => {
        if (manual) getMachinesPageAux();
    }, [pagination, filters, sorting, query]);

    const getAllMachinesAux = () => {
        setLoading(true);
        getAllMachines(user.token)
            .then((json: Machine[]) => {
                setMachines(json);
            })
            .catch(() => {
                showToastTimeOut(t('ErrorLoad'), true);
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            });
    };

    const getAllInstalationsAux = () => {
        getAllInstalations(user.token)
            .then(json => {
                setAllInstalations(json);
                const instalationsObj = json.map((i: Instalation) => ({
                    label: i.name,
                    value: i.idinstalation,
                }));
                setAllInstalationsObj(instalationsObj);
            })
            .catch(e => {
                console.log('Get Instalations Error', e);
            });
    };

    const saveClick = () => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noEditPermissions'), true);
            return;
        }
        if (newEditDelObj.name.length !== 0) {
            newMachine(user.token, newEditDelObj)
                .then((json: Machine) => {
                    let m = [];
                    let msg = t('CreatedMachineOK');

                    if (newEditDelObj.idmachine > 0) {
                        msg = t('UpdatedMachineOK');
                        const newMachines = machines.filter(m => m.idmachine !== json.idmachine);
                        m = [...newMachines, json];
                    } else {
                        m = [...machines, json];
                    }

                    setMachines(m);
                    setIsNew(false);
                    setNewEditDelObj(new Machine());
                    showToastTimeOut(msg, false);
                })
                .catch(() => {
                    setIsNew(false);
                    setNewEditDelObj(new Machine());
                    showToastTimeOut(t('MachineError'), true);
                });
        } else {
            showToastTimeOut(t('RequireParams'), true);
        }
    };

    const onChangeInstalation = (e: any) => {
        setSelectedInstalation(e);
        const instalation = allInstalations.find((i: Instalation) => i.idinstalation === e.value);
        if (instalation) {
            setNewEditDelObj(prevValues => ({
                ...prevValues,
                instalation: instalation,
            }));
        }
    };

    const cancelClick = () => {
        setIsNew(false);
        setNewEditDelObj(new Machine());
    };

    const editClick = (m: Machine) => {
        if (m.instalation) {
            setSelectedInstalation({
                label: m.instalation.name,
                value: m.instalation.idinstalation,
            });
        }
        setIsNew(true);
        setFormLock(true);
        setNewEditDelObj(m);
    };

    const deleteClick = (m: Machine) => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noDeletePermissions'), true);
        } else {
            setShowModal(true);
            setNewEditDelObj(m);
        }
    };

    const DesBloquearClick = () => {
        setFormLock(!formLock);
    };

    const onFormChange = (event: any) => {
        const { name, value } = event.target;
        if (name === 'active') {
            setNewEditDelObj((data: any) => ({
                ...data,
                active: !newEditDelObj.active,
            }));
        } else {
            setNewEditDelObj((data: any) => ({
                ...data,
                [name]: value,
            }));
        }
    };

    const onSetToken = (t: string) => {
        setNewEditDelObj((data: any) => ({
            ...data,
            token: t,
        }));
    };

    const ModalNo = () => {
        setShowModal(false);
    };

    const ModalYes = () => {
        setShowModal(false);

        deleteMachine(user.token, newEditDelObj.idmachine)
            .then((response: any) => {
                if (response.status >= 200 && response.status < 300) {
                    const newMachines = machines.filter(machines => machines !== newEditDelObj);
                    setMachines(newMachines);
                    setNewEditDelObj(new Machine());
                    showToastTimeOut(t('DeleteMachineOK'), false);
                } else {
                    throw new Error();
                }
            })
            .catch(() => {
                setNewEditDelObj(new Machine());
                showToastTimeOut(t('DeleteMachineError'), true);
            });
    };

    const onDownloadFile = (m: Machine) => {
        if (m.idmachine > 0) {
            downloadFile(generateFile(m), `${m.name}.token`);
        } else {
            showToastTimeOut(t('SaveMachineConfigFirst'), true);
        }
    };

    const onSelectedImage = (name: string, img: string) => {
        setNewEditDelObj((data: any) => ({
            ...data,
            machine_images: {
                ...data.machine_images,
                [name]: img,
            },
        }));
    };
    const [predefinedfiltersValue, setPredifinedFiltersValue] = useState<(number |string)[]>([])
    const filtri={
        predefinedFilters: [{value:1, label: `${t('Installation')}: Vic`, filterConditions:[{ id:'instalation', value: ['Vic']}]}, {value:2,label:`${t('NumSerie')}: 0001548465`, filterConditions:[{id:'serial_number', value:['000154826']}]}],
        predefinedFiltersValue: predefinedfiltersValue,
        generalFilters: filters,
        clearGeneralFilters: ()=>  {setFilters([]); setPredifinedFiltersValue([]); getMachinesPageAux()},
        onChangePredefinedFiltersValue: (val: (number |string)[]) => {
            const selectedFilters = filtri.predefinedFilters
                .filter(f => val.includes(f.value))
                .flatMap(f => f.filterConditions);

            setFilters(prev => {
                const idsPredefined = filtri.predefinedFilters.flatMap(f => f.filterConditions.map(a => a.id));
                const filteredPrev = prev.filter(p => !idsPredefined.includes(p.id));
                return [...filteredPrev, ...selectedFilters];
            });

            setPredifinedFiltersValue(val);

            getMachinesPageAux();
}   }
    return (
        <>
            <NotificationToast showToast={toast.showToast} msg={toast.msg} fail={toast.fail} />
            <ModalComponent
                showModal={showModal}
                textDel={`${t('QuestionDelete')} ${newEditDelObj.name}?`}
                onClickNo={ModalNo}
                onClickYes={ModalYes}
            />
            <div className="row border-0 ms-2 me-2" style={{ maxWidth: '100%' }}>
                <div className="col-12 col-md-12 p-1">
                    <ButtonsLine
                        comboOptions={[]}
                        onChangeSelected={() => {
                            return null;
                        }}
                        selectedOption={null}
                        edit={isNew}
                        viewMode={false}
                        formLock={formLock}
                        onClickNew={newClick}
                        onClickSave={saveClick}
                        onClickCancel={cancelClick}
                        onClickDesBloquear={DesBloquearClick}
                        comboOptions2={[]}
                        onChangeSelected2={() => {
                            return null;
                        }}
                        selectedOption2={null}
                        comboName=""
                        comboName2=""
                        classNameDanger="btn-Custom btn-IDRed"
                        classNamePrimary="btn-Custom btn-Grey" classNameSuccess="btn-Custom btn-IDGreen" classNameNeutral="btn-Simple"
                        containerColor="var(--background-secondary)"
                        rounded="rounded-1"
                        dark={true}
                        saveText={t('Save')}
                    >
                       <SearchPanel
                       searchAction={(query) => setQuery(query)} searchPlaceholder={t('Search')} options={filtri.predefinedFilters} value={filtri.predefinedFiltersValue} onChange={filtri.onChangePredefinedFiltersValue}                       
                       />
                    </ButtonsLine>
                </div>
            </div>
            <div className="row border-0 ms-2 me-2" style={{ maxWidth: '100%' }}>
                <div className="col-12 col-md-12 p-1">
                    {isNew ? (
                        <MachineForm
                            onSelectedFile={onSelectedImage}
                            edit={isNew}
                            machineAux={newEditDelObj}
                            sendChange={onFormChange}
                            onDownloadFile={onDownloadFile}
                            formLock={formLock}
                            selectedContainer={selectedInstalation}
                            onChangeSelectContainer={onChangeInstalation}
                            optionsContainers={allInstalationsObj}
                            onSetToken={onSetToken}
                            token={user.token}
                        />
                    ) : (
                        <MachineGrid
                            machines={machines}
                            onEditClick={editClick}
                            onDeleteClick={deleteClick}
                            edit={true}
                            onMachineClick={() => {
                                return false;
                            }}
                            instalations={allInstalations}
                            loading={loding}
                            pagination={pagination}
                            total={total}
                            setPagination={setPagination}
                            filters={filters}
                            setFilters={setFilters}
                            sorting={sorting}
                            setSorting={setSorting}
                            manual={manual}
                            globalFilter={query}
                            onGlobalFilterChange={setQuery}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default MachinesPage;
